/**
 * Canonical toast/notification adapter.
 * Wraps UnifiedNotificationSystem and supports both call signatures:
 *   showToast(message, icon)   — legacy icon-name API (e.g. 'exclamation-triangle')
 *   showToast(message, type)   — direct type API (e.g. 'error', 'success')
 *   showToast(message, type, options) — full options API
 */
import notificationSystem, {
  showSuccess,
  showError,
  showWarning,
  showInfo,
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
} from './UnifiedNotificationSystem.js';

const KNOWN_TYPES = new Set(['success', 'error', 'warning', 'info', 'locked']);

const ICON_TO_TYPE = {
  'check-circle': 'success',
  'exclamation-triangle': 'error',
  'exclamation-circle': 'warning',
  'info-circle': 'info',
  'trash': 'info',
  'lock': 'locked',
};

export const showToast = (message, iconOrType = 'info', options = {}) => {
  const type = KNOWN_TYPES.has(iconOrType)
    ? iconOrType
    : (ICON_TO_TYPE[iconOrType] ?? 'info');
  return notificationSystem.show({ message, type, ...options });
};

export {
  showSuccess,
  showError,
  showWarning,
  showInfo,
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
};

export const toast = {
  show: showToast,
  success: showSuccessToast,
  error: showErrorToast,
  info: showInfoToast,
  warning: showWarningToast,
};

export default toast;
